import { render, staticRenderFns } from "./FlashProducts.vue?vue&type=template&id=61a46a89&"
import script from "./FlashProducts.vue?vue&type=script&lang=js&"
export * from "./FlashProducts.vue?vue&type=script&lang=js&"
import style0 from "./FlashProducts.vue?vue&type=style&index=0&id=61a46a89&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports